import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Link from 'react-router/lib/Link';
import RosettaFormattedMessage from '../common/rosetta_formatted_message';
import { sendDataLayerEvent } from '../../utils/analytics';
import { FaIcon } from '../common/fa_icons';

class PrimaryTagBanner extends Component {
  handleClick = () => {
    sendDataLayerEvent('Click', {
      linkType: 'channel',
      pageModule: 'Main Content',
      linkTitle: this.props.name,
      linkURL: this.props.url
    });
  }

  render() {
    const { name, url } = this.props;
    return (
      <div className="primary-tag-banner">
        <Link to={url} onClick={this.handleClick}>
          <span className="story-from">
            <RosettaFormattedMessage parentFilename={__filename}
              id="story_from"
              description="Link to the primary tag of an article"
              defaultMessage="Story from {name}"
              values={{
                name: (
                  <span className="tag-name"
                    dangerouslySetInnerHTML={{ __html: name }}
                  />
                )
              }}
            />
          </span>
          <FaIcon iconName="angle-right" />
        </Link>
      </div>
    );
  }
}

PrimaryTagBanner.propTypes = {
  name: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired
};

export default PrimaryTagBanner;
